import types from '../types';
import createReducer from '../utils/createReducer';
import INITIAL_STATE from './initialState';
import { BLOCKING_LOADER, APP_INIT_ERROR, GET_ASSOCIATED_HOTELS } from '../../../common/actionTypes/adminTypes'

const initialState = INITIAL_STATE.app;

const reducerMap = {
  [types.app.SIGN_OUT_USER_SUCCESS]: (state, action) => {
    for (const key in initialState) {
      state[key] = initialState[key];
    }
    state.isLoggedIn = false;
    state.userDetails = {};
  },
  [types.app.SET_LOCALE]: (state, action) => {
    state.locale = action.payload.locale;
  },
  [types.app.SIGN_IN_USER_SUCCESS]: (state, action) => {
    const { millis_left_for_password_expiry } = action.payload.data;
    return {
      ...state,
      userDetails: {
        ...action.payload.data,
        password_expiry: {
          millisLeftForPassExpiry: millis_left_for_password_expiry,
          updatedAt: new Date().getTime()
        }
      }
    };
  },
  [types.app.SET_USER_DETAILS]: (state, action) => {
    state.userDetails = action.payload.userDetails;
    state.isLoggedIn = action.payload.isLoggedIn;
  },
  [BLOCKING_LOADER]: (state, action) => ({ ...state, isBlockingLoaderActive: action.payload.status }),
  [APP_INIT_ERROR]: (state, action) => ({
    ...state,
    hasAppInitError: action.payload
  }),
  [GET_ASSOCIATED_HOTELS]: (state, action) => {
    const { active_hotel_id, active_hotel, currency_symbol, defaultCountryIndex } = action.payload;
    return {
      ...state,
      active_hotel_id,
      active_hotel,
      currency_symbol,
      defaultCountryIndex,
      hasAppInitError: false
    };
  }
};

export default createReducer(initialState, reducerMap);
